import React, {useEffect} from 'react';
import InputData from "./InputData";
import useCommonAPI from "../../api/CommonAPI";

function TillsInput({tills, setTills}) {

    const { getAllTillTypes, tillTypes } = useCommonAPI();

    function handleAddTill() {
        setTills([...tills, {ReferenceNo: '', TypePOSValue: tillTypes[0].value, TypePOSLabel: tillTypes[0].label}]);
    }

    function handleRemoveTill(index) {
        setTills(tills.filter((_, i) => i !== index));
    }

    function handleTillInputChange(event, index, key) {
        const {value} = event.target;
        setTills(
            tills.map((till, i) =>
                i === index ? {...till, [key]: value} : till
            )
        );
    }

    useEffect(() => {
        tills.map((till, index) => {
            if (till.ReferenceNo.length !== 0 && till.TypePOSValue.length === 0) {
                const updatedTill = {
                    ...till,
                    TypePOSValue: tillTypes[0].value,
                    TypePOSLabel: tillTypes[0].label
                };
                setTills((prevState) => {
                    const updatedTills = [...prevState];
                    updatedTills[index] = updatedTill;
                    return updatedTills;
                });
            }
        });
    }, [tills]);


    useEffect(()=>{
        getAllTillTypes();
    }, []);

    return (
        <>
            <div className="row pt-2 mt-5">
                <div className='row'>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Till</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Type of POS</div>
                        </div>
                    </div>
                </div>
            </div>

            <InputData
                type="till"
                data={tills}
                handleAdd={handleAddTill}
                handleRemove={handleRemoveTill}
                handleInputChange={handleTillInputChange}
                types={tillTypes}
                setData={setTills}
            />
        </>

    );
}

export default TillsInput;